import React from 'react';
import Navigation from '@/components/Navigation';
import AnimatedBackground from '@/components/AnimatedBackground';
import AboutContent from '@/components/about/AboutContent';

const About = () => {
  return (
    <div className="min-h-screen relative">
      <AnimatedBackground />
      <Navigation />
      
      <main className="pt-24 pb-16 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Main about content */}
          <div className="mb-16">
            <AboutContent />
          </div>
        </div>
      </main>
    </div>
  );
};

export default About;
